import request from "@/network/request"

// 查询微信公众号处方支付信息
export function queryDietaryguidance(data) {
	return request({
		url: "/api/app/advice/get",
		method: 'post',
		data,
	});
}
